"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectUserFuturesLeveragePreferences = exports.getFuturesLeverageState = exports.futuresMaxLeverageSelector = exports.futuresLeverageSubmittingSelector = exports.currentPositionLeverageSelector = exports.currentFuturesLeverageSelector = void 0;
var _reselect = require("reselect");
var _futuresInstrumentsSelector = require("./futuresInstrumentsSelector");
var _futuresPositionsSelectors = require("./futuresPositionsSelectors");
var getFuturesLeverageState = exports.getFuturesLeverageState = function getFuturesLeverageState(state) {
  return state.futures.leverages;
};
var selectUserFuturesLeveragePreferences = exports.selectUserFuturesLeveragePreferences = function selectUserFuturesLeveragePreferences(state) {
  return getFuturesLeverageState(state).leverages;
};
var futuresLeverageSubmittingSelector = exports.futuresLeverageSubmittingSelector = function futuresLeverageSubmittingSelector(state) {
  return getFuturesLeverageState(state).submitting;
};
var futuresMaxLeverageSelector = exports.futuresMaxLeverageSelector = (0, _reselect.createSelector)(_futuresInstrumentsSelector.futuresSelectedInstrumentSelector, function (instrument) {
  var _instrument$MaximumLe;
  return (_instrument$MaximumLe = instrument === null || instrument === void 0 ? void 0 : instrument.MaximumLeverage) !== null && _instrument$MaximumLe !== void 0 ? _instrument$MaximumLe : 0;
});
var currentFuturesLeverageSelector = exports.currentFuturesLeverageSelector = (0, _reselect.createSelector)([selectUserFuturesLeveragePreferences, _futuresInstrumentsSelector.futuresSelectedInstrumentIdSelector, futuresMaxLeverageSelector], function (leverages, instrumentId, maxLeverage) {
  return leverages && leverages[instrumentId] && (!maxLeverage || leverages[instrumentId] <= maxLeverage) ? leverages[instrumentId] : null;
});
var currentPositionLeverageSelector = exports.currentPositionLeverageSelector = (0, _reselect.createSelector)(_futuresPositionsSelectors.getSelectedInstrumentPositionSelector, function (position) {
  return position === null || position === void 0 ? void 0 : position.Leverage;
});